import React from 'react'
import TableCell from '@mui/material/TableCell'
import { SxProps, Theme } from '@mui/system'

interface TransitionCellProps {
  open: boolean
  sx?: SxProps<Theme>
  align?: 'inherit' | 'left' | 'center' | 'right' | 'justify'
  children?: React.ReactNode
  colSpan?: number
}

const TransitionTableCell: React.FC<TransitionCellProps> = ({ open, sx, align, children, ...props }) => {
  return (
    <TableCell
      align={align}
      sx={{
        maxHeight: open ? 'none' : 0,
        lineHeight: open ? 'auto' : 0,
        opacity: open ? 1 : 0,
        transition:
          'opacity 450ms ease, height 300ms ease, max-height 300ms ease, line-height 300ms ease, padding-top 600ms ease, padding-bottom 600ms ease',
        overflow: 'hidden',
        py: open ? 1 : 0,
        borderBottom: open ? '1px solid' : '0px',
        borderColor: 'background.elevation7',
        backgroundColor: 'background.elevation2',
        ...sx,
      }}
      {...props}
    >
      {children}
    </TableCell>
  )
}

export default TransitionTableCell
